import React from 'react';

export default function AboutUsSectionTeamWhitePattern6() {
    return (
        <React.Fragment>
            <>
                <section className="py-24 bg-coolGray-900" style={{ backgroundImage: 'url("flex-ui-assets/elements/pattern-dark2.svg")', backgroundPosition: 'center' }}>  <div className="container px-4 mx-auto">    <div className="max-w-4xl mx-auto text-center mb-16">
    <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Our Team</span>
    <h3 className="mb-4 text-4xl md:text-5xl leading-tight text-white font-bold tracking-tighter">Meet Our Team</h3>
    <p className="text-lg md:text-xl text-coolGray-400 font-medium">Our leadership team brings decades of expertise and a passion for innovation to every project at Bagga International.</p>
</div>
<div className="flex flex-wrap -mx-4">
                        <div className="w-full md:w-1/2 px-4 mb-12">
                            <div className="bg-coolGray-800 rounded-lg shadow-lg p-6 flex flex-col items-center h-full">
  <img className="block mb-6 max-w-[96px] mx-auto" src="https://static.shuffle.dev/uploads/files/da/da461d2186774c4a21cf5c73ffae28f6985abb13/avatar-1577909-1280.png" alt="Rajinder Kumar Bagga" />
  <h3 className="mb-2 text-2xl md:text-3xl leading-tight text-white font-semibold">Rajinder Kumar Bagga</h3>
  <span className="text-base font-medium text-green-500">CEO &amp; Founder</span>
</div>
                        </div>
                        <div className="w-full md:w-1/2 px-4 mb-12">
                            <div className="bg-coolGray-800 rounded-lg shadow-lg p-6 flex flex-col items-center h-full">
  <img className="block mb-6 max-w-[96px] mx-auto" src="https://static.shuffle.dev/uploads/files/da/da461d2186774c4a21cf5c73ffae28f6985abb13/avatar-1577909-1280.png" alt="Chirag Bagga" />
  <h3 className="mb-2 text-2xl md:text-3xl leading-tight text-white font-semibold">Chirag Bagga</h3>
  <span className="text-base font-medium text-green-500">CTO</span>
</div>
                        </div>
                    </div></div></section>
            </>
        </React.Fragment>
    );
}

